export function fromBase64(base64: string): string {
  return typeof window === 'undefined'
    ? Buffer.from(base64, 'base64').toString('utf8')
    : atob(base64);
}

export function toBase64(str: string): string {
  return typeof window === 'undefined' ? Buffer.from(str, 'utf8').toString('base64') : btoa(str);
}
